module.exports = __webpack_public_path__ + "img/ai-infrastructure.335096a3.svg";